module.exports = __webpack_public_path__ + "MD.c86f80e9.png";